import React from 'react'
import PropTypes from 'prop-types'
import GppBad from '@mui/icons-material/GppBad'

const GppBadIcon = ({ height, width, ...more }) => {
	
	return (
		<GppBad
			height={height}
			width={width}
			{...more}
		/>
	)
}

GppBadIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default GppBadIcon
